import * as R from 'ramda';
export default (selectedCells, row, column) => R.any(cell => cell.row === row && cell.column === column, selectedCells);
